import React, { useState, useEffect } from 'react';
import GetIcon from '../../../../../utils/Icon';
import Input from '../../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';

function Tab2({ tab1CustomerData, setTab2Data }) {
  const shippingAddresses = tab1CustomerData?.customerDetails?.result?.shipping_addresses || [];
  const billingAddress = tab1CustomerData?.customerDetails?.result?.billing_addresses || [];
  const gst_category = tab1CustomerData?.customerDetails?.result?.gst_category || '';
  const mobile_number = tab1CustomerData?.customerDetails?.result?.mobile_number || '';
  const territory = tab1CustomerData?.customerDetails?.result?.territory || '';

  const [selectedShipping, setSelectedShipping] = useState('');
  const [selectedBilling, setSelectedBilling] = useState('');

  useEffect(() => {
    if (shippingAddresses.length > 0) {
      const first = shippingAddresses[0];
      setSelectedShipping(first.name);
      setTab2Data(prev => ({
        ...prev,
        shipping_addresses: first.name
      }));
    }
    if (billingAddress.length > 0) {
      const first = billingAddress[0];
      setSelectedBilling(first.name);
      setTab2Data(prev => ({
        ...prev,
        billing_address: first.name
      }));
    }
  }, [shippingAddresses, billingAddress]);

  const handleSelectBilling = (value) => {
    setSelectedBilling(value);
    setTab2Data(prev => ({
      ...prev,
      billing_address: value
    }));
  };

  const handleSelectShipping = (value) => {
    setSelectedShipping(value);
    setTab2Data(prev => ({
      ...prev,
      shipping_addresses: value
    }));
  };

  // Format addresses for SelectSearch component
  const formatShippingOptions = shippingAddresses.map(addr => ({
    name: addr.name,
    label: `${addr.address_line1}, ${addr.city}, ${addr.country}`
  }));

  const formatBillingOptions = billingAddress.map(addr => ({
    name: addr.name,
    label: `${addr.address_line1}, ${addr.city}, ${addr.country}`
  }));

  return (
    <div style={{ height: '74vh', }}>
      <div className="row m-0" style={{ padding: "8px", borderRadius: "5px", }}>



        <div className="col-12">
          <div className="tableLabel">
            <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>Billing Address</p>
            <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
          </div>
        </div>

        <div className="col-md-4 mt-0">
          <SelectSearch
            list={formatBillingOptions}
            label="Select Billing Address"
            getOptionLabel={(item) => item.label}
            getOptionValue={(item) => item.name}
            value={selectedBilling}
            onChange={handleSelectBilling}
            // placeholder="Select Billing Address"
            style={{ height: "30px" }}
          />
        </div>

        <div className="col-md-4 mt-0">
          <Input
            id="CustomerContact"
            label="Customer Contact"
            value={mobile_number}
            readOnly
            style={{ height: "30px" }}
          />
        </div>

        <div className="col-md-4 mt-0">
          <Input
            id="GSTCategory"
            label="GST Category"
            value={gst_category}
            readOnly
            style={{ height: "30px" }}
          />
        </div>

        <div className="col-12 mt-2">
          <div className="tableLabel">
            <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>Shipping Address</p>
            <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
          </div>
        </div>

        <div className="col-md-4 mt-0">
          <SelectSearch
            list={formatShippingOptions}
            label="Select Shipping Address"
            getOptionLabel={(item) => item.label}
            getOptionValue={(item) => item.name}
            value={selectedShipping}
            onChange={handleSelectShipping}
            // placeholder="Select Shipping Address"
            style={{ height: "30px" }}
          />
        </div>

        <div className="col-md-4 mt-0 mb-5">
          <Input
            id="Territory"
            label="Territory"
            value={territory}
            readOnly
            style={{ height: "30px" }}
          />
        </div>
      </div>
    </div>
  );
}

export default Tab2;